import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { StockCategoryModel } from './stock-category/model/stock-category.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class StockCategoryService {


  constructor(private http: HttpClient) { }

  
  getList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/category/get', requestData);

  }
 
  getParentCategory(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/category/getParentCategory', requestData);

  }

  getById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/category/get/'+id, '');

  }

   /**
   * 
   * @param areaInfo 
   * Calls the update API to insert/update the record
   */
   update(stockCategoryInfo: StockCategoryModel): Observable<any> { 
    if(stockCategoryInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/category/update', stockCategoryInfo);
    } else{
      return this.http.post(environment.baseUrl+'/category/add', stockCategoryInfo);
    }
  }


    /**
   * 
   * @param areaInfo 
   * Calls the API to delete the record
   */
    delete(stockCategoryInfo: StockCategoryModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/category/delete/'+stockCategoryInfo.id, stockCategoryInfo);
    }
    downloadExcel(requestData: any): Observable<Blob> {
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
     // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
  
      return this.http.post(environment.baseUrl + '/category/export-stock-category', requestData, { headers, responseType: 'blob' })
        .pipe(
          //catchError(this.handleError)
        );
  
    }
}





